<template>
  <main class="login-shell">
    <section class="login-panel">
      <h1>{{ connectionTest ? 'University sign-in test complete' : errorCode === 'sso_retry' ? 'Please try signing in again' : errorCode === 'access_pending' ? 'Your sign-in is verified' : error ? 'Access is not ready' : 'Signing in' }}</h1>
      <p v-if="connectionTest" class="mt-4">University authentication completed successfully. No product access has been granted. Return to the onboarding tab and record this result with the email mapping, stable NameID and MFA evidence from university IT.</p>
      <p v-if="error" class="notice" :class="{ error: errorCode !== 'access_pending' }">{{ error }}</p>
      <p v-else-if="!connectionTest">Checking your Orator Pro access…</p>
      <router-link v-if="error" :to="{ path: '/login', query: { sso: '1', connection_test: retryTestDomain || undefined } }">Back to sign in</router-link>
    </section>
  </main>
</template>

<script>
import { exchangeSharedSignIn } from "@/lib/api";
import { setSession } from "@/lib/auth";
import { finishSharedSignIn } from "@/lib/sharedSso";

export default {
  name: "SsoCallback",
  data: () => ({ connectionTest: false, retryTestDomain: "", error: "", errorCode: "" }),
  async mounted() {
    try {
      const { accessToken, destination, connectionTest } = await finishSharedSignIn();
      if (connectionTest) { this.connectionTest = true; return; }
      const session = await exchangeSharedSignIn(accessToken);
      setSession(session);
      await this.$router.replace(destination);
    } catch (error) {
      const code = error?.response?.data?.code || error.code;
      this.retryTestDomain = error.connectionTest || "";
      this.errorCode = code || 'error';
      if (code === 'access_pending') {
        this.error = 'We are linking your approved Orator Pro account. You do not need to try again now. We will email you when access is ready.';
      } else if (code === 'sso_retry') {
        this.error = 'Your sign-in attempt expired or was interrupted. Start again using organisation sign-in. If it keeps happening, contact your MGC administrator.';
      } else if (code === 'no_access') {
        this.error = 'Your organisation sign-in worked, but you do not have Orator Pro access. Contact your MGC administrator to request it.';
      } else {
        this.error = 'Shared sign-in could not be completed. Ask your MGC administrator to check your access.';
      }
    }
  },
};
</script>

<style scoped>
.login-shell { min-height: 100vh; display: grid; place-items: center; padding: 1rem; }
.login-panel { width: min(100%, 420px); padding: 2rem; background: white; }
.notice { margin: 1rem 0; }
.error { color: #991b1b; }
</style>
